import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { ToastrService } from 'ngx-toastr';
import { MainGlobalEventService } from '../../../../../../_shared/services/main-global-event.service';
import { CreditorService } from '../../../../../creditor/creditor.service';
import { DocumentTypeService } from '../../../../../document/document-type.service';
import { CaseAssetService } from '../../../../case-asset.service';
import { CaseCreditorService } from '../../../../case-creditor.service';
import {
  BaseDocumentFileUploaderComponent
} from '../base-document-file-uploader/base-document-file-uploader.component';

@Component({
  selector:    'app-case-client-requested-document-list-v3',
  templateUrl: '../base-document-file-uploader/base-document-file-uploader.component.html',
  styleUrls:   ['../base-document-file-uploader/base-document-file-uploader.component.scss'],
  standalone:  false
})
export class CaseClientRequestedDocumentListV3Component extends BaseDocumentFileUploaderComponent implements OnInit, OnDestroy {

  constructor(
    protected fb: FormBuilder,
    protected dialog: MatDialog,
    protected toastr: ToastrService,
    protected cookieService: CookieService,
    protected translate: TranslateService,
    protected globalEventsService: MainGlobalEventService,
    protected documentTypeService: DocumentTypeService,
    protected caseCreditorService: CaseCreditorService,
    protected caseAssetService: CaseAssetService,
    protected creditorService: CreditorService,
  ) {
    super(
      fb,
      dialog,
      toastr,
      cookieService,
      translate,
      globalEventsService,
      documentTypeService,
      caseCreditorService,
      caseAssetService,
      creditorService,
    );
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.loadDocumentTypeCategories();
  }

  public loadDocumentTypeCategories(): void {
    const requestData: any = {
      client_role:                       this.clientRole,
      ...(this.docRequestCompletedStatus ? { document_request_completed_status: this.docRequestCompletedStatus } : {}),
      show_inactive:                     true,
      has_request:                       true,
      types:                             ['client_case', 'client_case_creditor', 'client_case_public_debt', 'client_case_asset', 'client_case_custom']
    };
    const relations        = ['document_types', 'document_types.document_type_requests', 'document_types.documents'];

    if (this.documentableType && this.documentableId) {
      requestData.documentable_type = this.documentableType;
      requestData.documentable_id   = this.documentableId;
    }

    this.caseDocumentTypeCategories = [];
    this.fetchDocumentTypeCategories(this.case, requestData, relations);
  }

}
